const searchToggle = (toggle) => {
    toggle.addEventListener("click", function () {
        var header = document.getElementsByClassName("main-header");
        var headerSearch = document.getElementById("header-search");
        var languageSwitch = document.getElementById("language-switch");
        var classes = headerSearch.getAttribute("class");
        if (!classes || classes.indexOf("open-search") == -1) {
            header[0].classList.toggle("open-search");
            if (header.length > 1) {
                header[1].classList.toggle("open-search");
            }
            toggle.parentNode.classList.toggle("open-search");
            headerSearch.classList.toggle("open-search");
            if (languageSwitch) {
                languageSwitch.classList.toggle("pushed-left");
            }
        } else {
            header[0].classList.remove("open-search");
            if (header.length > 1) {
                header[1].classList.remove("open-search");
            }
            toggle.parentNode.classList.remove("open-search");
            headerSearch.classList.remove("open-search");
            if (languageSwitch) {
                languageSwitch.classList.remove("pushed-left");
            }
        }
    });
};


export { searchToggle };
